import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'spaq-auth-page',
  template: `
    <spaq-layout-auth>
      <router-outlet></router-outlet>
    </spaq-layout-auth>
  `,
  styles: [],
})

export class AuthPageComponent implements OnInit {

  constructor(private route: Router) {

  }

  ngOnInit() {
  }
}




// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/__/containers/auth-page.component.ts